/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../reducers';

export enum SurveyOverviewMode {
  Universal,
  Scope,
  ScopeGroups,
  SdgAndScope,
  QuestionList,
};

interface InitialState {
  overviewMode: SurveyOverviewMode
}

const initialState: InitialState = {
  overviewMode: SurveyOverviewMode.ScopeGroups,
};

const surveySettingsSlice = createSlice({
  name: 'surveySettings',
  initialState,
  reducers: {
    setOverviewMode: (state, action) => {
      return { ...state, overviewMode: action.payload }
    },
  }
})

const { actions } = surveySettingsSlice;

export const setOverviewMode = (mode: SurveyOverviewMode) => (dispatch: any, getState: () => RootState) => {
  if (getState().surveySettings.overviewMode === mode) {
    return;
  }

  dispatch(actions.setOverviewMode(mode));
}

export default surveySettingsSlice.reducer
